
<mat-dialog-content>
<div class="row">
<div class="col-sm-6">

    <mat-card>
        <mat-card-title class="font-weight-bold caption-color">SPRA Product Details</mat-card-title>
        <mat-divider></mat-divider>
        
        <mat-card-content class="pt-2">

            <table class="table">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>SPRA Qty.</th> 
                        <th>Remaining Qty.</th>                     
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of products; let i = index;">
                        <td  [ngClass]="{'font-red-flamingo' : item.RemainingQty<0}">{{item.ProductCode}}</td>
                        <td>{{item.SpraQuantity}}</td>
                        <td>{{item.RemainingQty}}</td>
                    </tr>
                </tbody>
                </table>
    
            
        </mat-card-content>
</mat-card>    

</div>
</div>
<br>
<div class="row">
<div class="col-sm-12">
    <mat-card>
        <mat-card-title class="font-weight-bold caption-color">{{contactConsigneeParams.AddressHeading}}</mat-card-title>
        <mat-divider></mat-divider>
        
        <mat-card-content class="pt-2">
            <table class="table">
                <thead>
                    <tr>
                        <th class="w-60">Consignee</th>
                        <th class="w-10" *ngIf="!this.ProfitTag">Action</th> 
                        <th class="w-30">Product Detail</th> 
                        
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of spraConsigneeRow; let i = index;">
                    <td>
                        <select name="ddlConsignee" [disabled]="ReviewedSpra" class="form-control" [(ngModel)]="item.ConsigneeId">
                          <option *ngFor="let ca of consigneeList"  value={{ca.consigneeId}}>{{(ca.address1 |
                            consigneeAddressCompletePipe:ca)}} </option>
                        </select>
                    </td>
                    <td *ngIf="item.IsNewRow && !this.ProfitTag" (click)="deleteRow(i,item)"> 
                        <i class="fa fa-trash fa-2x"></i>
                    </td>
                    <td  *ngIf="!item.IsNewRow" (click)="addRow(item,i)">
                        <i class="fa fa-plus fa-2x"></i>
                    </td>
                    <td>
    
    
                        <table class="table">                        
                            <tbody>
                                <tr *ngFor="let item1 of item.ProductDetails; let i = index;">
                                    <td>
                                        <b>Prod Code : </b>{{item1.ProductCode }}
                                    </td>
                                    <td>
                                        <input type="number" name="txtQuantity" (input)="ChangeQty();" [(ngModel)]="item1.Quantity" class="form-control" >
                                    </td>                 
    
                                </tr>
                                </tbody>
                                </table>
    
                    </td>
                   
    
                  
                                    
                    </tr>
    
                    </tbody>
                    </table>


                    
                    <mat-divider></mat-divider>
                    <div class="row">
                        <div class="col-sm-12 text-right">
                            <button type="button" class="btn btn-primary" (click)="Close()">Submit</button>
                        </div>
                    </div>
                    
                    
        </mat-card-content>


</mat-card> 
</div>
</div>
</mat-dialog-content>